import { loadMicroApp } from 'qiankun'
import store from '@/store/index'
import { getRefreshToken } from './user'

const { NODE_ENV } = process.env

export const subAppEntry = () => {
  const { origin, pathname } = window.location
  if (NODE_ENV.includes('dev')) {
    return pathname ? `http://localhost:8060${pathname}flow/` : `http://localhost:8060/flow/`
  }

  return pathname ? `${origin}${pathname}/flow/` : `${origin}/flow/`
}

export const isSubAppFlowPath = (path) => {
  return /^\/flowEditor/.test(path)
}

export const loadSubAppFlow = async (nodeId) => {
  const nodeID = nodeId || store.state.currentNode.id
  const { user } = store.state
  const { lang } = store.state
  user.token = await getRefreshToken()

  if (store.state.subAppInstances.flow) {
    return
  }
  try {
    store.commit('SET_SUB_APP_LOADING', true)
    await new Promise((resolve) => window.setTimeout(resolve, 100))
    const app = loadMicroApp(
      {
        name: 'flow-ekuiper',
        entry: subAppEntry(),
        container: '#flow-container',
        props: {
          // routePathPrefix: '/flowEditor',
          nodeId: nodeID,
          lang,
          user,
        },
      },
      {
        sandBox: {
          strictStyleIsolation: true,
        },
      },
    )
    store.commit('SET_SUB_APP_INSTANCE', { key: 'flow', instance: app })
    await app.loadPromise
  } finally {
    store.commit('SET_SUB_APP_LOADING', false)
  }
}

export const isExitSubAppFlow = (fromPath, toPath) => {
  return isSubAppFlowPath(fromPath) && !isSubAppFlowPath(toPath)
}

const removeAllIViewEle = () => {
  const elements = Array.from(document.querySelectorAll('body > [class^="el"]'))
  elements.forEach((item) => {
    item.remove()
  })
}
export const destroySubAppFlow = () => {
  if (store.state.subAppInstances.flow) {
    store.state.subAppInstances.flow.unmount()
  }
  store.commit('SET_SUB_APP_INSTANCE', { key: 'flow', instance: null })
}

export const exitSubAppFlow = async () => {
  destroySubAppFlow()
  removeAllIViewEle()
}
